export const planos = {
    // 6: { 
    //     nome: 'Grass Digital Assets Spirit FI', 
    //     investimento: 2000000, 
    //     rentabilidade: 0.90, 
    //     meses: { 6: 0.90 } 
    // },
    // 15: { 
    //     nome: 'Genesis - 4 meses', 
    //     investimento: 50000, 
    //     rentabilidade: 24, 
    //     meses: { 4: 24 } 
    // },
    // 16: { 
    //     nome: 'Crypto Exclusive - 8 meses', 
    //     investimento: 50000, 
    //     rentabilidade: 24, 
    //     meses: { 8: 24 } 
    // },
    17: {
        nome: 'Digital Prestige - 6 meses', 
        investimento: 100, 
        rentabilidade: 24, 
        meses: {6: 24}
    },
    18: { 
        nome: 'Quantum Prime - 12 meses', 
        investimento: 100, 
        rentabilidade: 24, 
        meses: { 12: 24 } 
    }
}

export const dadosBancarios = {
    banco: "336 - Banco C6 S.A",
    nome: "UP365CAPITAL LTDA",
    cnpj: "48.807.400/0001-30",
    agencia: "0001",
    conta: "30397235-1",
    pix: "48.807.400/0001-30"
}

export const periodos = {
    4: {select: 'Jan/2025 - Abr/2025'},
    8: {select: 'Jan/2025 - Ago/2025'},
    10: {select: 'Jan/2025 - Out/2025'},
    12: {select: 'Jan/2025 - Dez/2025'},
}

export const meses = {
    0: 'Início',
    1: 'Jan/2025',
    2: 'Fev/2025',
    3: 'Mar/2025',
    4: 'Abr/2025',
    5: 'Mai/2025',
    6: 'Jun/2025',
    7: 'Jul/2025',
    8: 'Ago/2025',
    9: 'Set/2025',
    10: 'Out/2025',
    11: 'Nov/2025',
    12: 'Dez/2025',
} 